import { Component, inject } from '@angular/core'
import { OAuthService } from 'angular-oauth2-oidc'

@Component({
  selector: 'lg-user-not-authenticated',
  imports: [],
  templateUrl: './user-not-authenticated.component.html',
  styleUrl: './user-not-authenticated.component.scss',
})
export class UserNotAuthenticatedComponent {
  oAuthService = inject(OAuthService);


  logout(): void {
    this.oAuthService.logOut({
      client_id: this.oAuthService.clientId,
      redirect_uri: this.oAuthService.redirectUri,
      response_type: 'code',
    })
  }
}
